import { render, staticRenderFns } from "./lssy1.vue?vue&type=template&id=4ff49396&scoped=true"
import script from "./lssy1.vue?vue&type=script&lang=js"
export * from "./lssy1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff49396",
  null
  
)

export default component.exports